<template>
  <!-- <div class="main-container"> -->
    <div>
      <!-- <div> -->
        <!-- <breadcrumb 
          :list="breadcrumbList"/>
        <br>
        <tl-header type="h1">
          <div class="main-header">FBP Settings</div>
        </tl-header>
        <br /> -->
         <toast-message 
          :message="errmsg" type="error" 
          :isToastEnable="toast"  @close ="(val) => toast = val"/>
        <br>
        <div>
            <div class="label-text">
              <b>FBP Year</b>
            </div>
            <br>
            <div class="row">
            <tl-radio
              class="col-2"
              label="Financial year"
              name="year"
              id="financial_year"
              value="financial_year"
              v-model="fbpSettingsData.year"
              @change="(val)=>fbpSettingsData.year=val"
            />

            <tl-radio
              class="col-3"
              label="Calendar year (Jan to Dec)"
              name="year"
              id="calendar_year"
              value="calendar_year"
              v-model="fbpSettingsData.year"
              @change="(val)=>fbpSettingsData.year=val"
            />
            <tl-radio
              class="col-3"
              label="Customized year"
              name="year"
              id="custom"
              value="custom"
              v-model="fbpSettingsData.year"
              @change="(val)=>fbpSettingsData.year=val"
            />
            </div>
            <br>
            <div class="row" v-if="fbpSettingsData.year=='custom'">
              <div class="col-5"></div>
                <tl-select 
                  class="col-2"
                  label="From" 
                  :value="from" 
                  :options="monthOptions" 
                  @change="(val)=>from=val" />
                    <tl-select 
                  class="col-2"
                  label="To" 
                  :value="from" 
                  :options="monthOptions" 
                  @change="(val)=>from=val" />
            </div>  
            <br> 
          </div>
         <div class="singleColumnGrid">
          <div class="label-text">
            <b>Date range for FBP declaration</b>
          </div>
        </div>
        <br> 
        <div class="row">
            <tl-radio
              class="col-2"
              label="Monthly"
              name="daterange"
              id="monthly"
              value="monthly"
              v-model="fbpSettingsData.date_range_for_declaration"
              @change="(val)=>fbpSettingsData.date_range_for_declaration=val"
            />

            <tl-radio
              class="col-2"
              label="Quaterly"
              name="daterange"
              id="quaterly"
              value="quaterly"
              v-model="fbpSettingsData.date_range_for_declaration"
              @change="(val)=>fbpSettingsData.date_range_for_declaration=val"
            />
            <tl-radio
              class="col-2"
              label="Half Yearly"
              name="daterange"
              id="bi_annually"
              value="bi_annually"
              v-model="fbpSettingsData.date_range_for_declaration"
              @change="(val)=>fbpSettingsData.date_range_for_declaration=val"
            />
            <tl-radio
              class="col-2"
              label="Annually"
              name="daterange"
              id="annually"
              value="annually"
              v-model="fbpSettingsData.date_range_for_declaration"
              @change="(val)=>fbpSettingsData.date_range_for_declaration=val"
            />
            </div>
           <br v-if="fbpSettingsData.date_range_for_declaration=='quaterly'">
           <div class="row" v-if="fbpSettingsData.date_range_for_declaration=='quaterly'">
              <div class="col-2"></div>
                <tl-select 
                  class="col-2"
                  label="Quarter One" 
                  :value="from" 
                  :options="monthOptions" 
                  @change="(val)=>from=val" />
                <tl-select 
                  class="col-2"
                  label="Quarter Two" 
                  :value="from" 
                  :options="monthOptions" 
                  @change="(val)=>from=val" />
                <tl-select 
                  class="col-2"
                  label="Quarter Three" 
                  :value="from" 
                  :options="monthOptions" 
                  @change="(val)=>from=val" />
                <tl-select 
                  class="col-2"
                  label="Quarter Four" 
                  :value="from" 
                  :options="monthOptions" 
                  @change="(val)=>from=val" />
            </div> 
            <br v-if="fbpSettingsData.date_range_for_declaration=='bi_annually'">
           <div class="row" v-if="fbpSettingsData.date_range_for_declaration=='bi_annually'">
              <div class="col-4"></div>
                <tl-select 
                  class="col-2"
                  label="First Half" 
                  :value="from" 
                  :options="monthOptions" 
                  @change="(val)=>from=val" />
                <tl-select 
                  class="col-2"
                  label="Second Half" 
                  :value="from" 
                  :options="monthOptions" 
                  @change="(val)=>from=val" />
            </div> 
           <br v-if="fbpSettingsData.date_range_for_declaration=='annually'">
           <div class="row" v-if="fbpSettingsData.date_range_for_declaration=='annually'">
              <div class="col-6"></div>
                <tl-select 
                  class="col-2"
                  label="Month" 
                  :value="from" 
                  :options="monthOptions" 
                  @change="(val)=>from=val" />
            </div> 
            <br>
            <div class="row">
              <!-- <div class="col-5"></div> -->
                <tl-select 
                  class="col-2"
                  label="From" 
                  :value="from" 
                  :options="monthOptions" 
                  @change="(val)=>from=val" />
                    <tl-select 
                  class="col-2"
                  label="To" 
                  :value="from" 
                  :options="monthOptions" 
                  @change="(val)=>from=val" />
            </div>  
            <br> 
        <br />
        <div class="singleColumnGrid">
          <div class="label-text">
            <b>Reminder Settings</b>
          </div>
          <div>
            <span class="input-label">Start Date</span>
           <date-picker 
             @datevalue="(val)=>fbpSettingsData.declarationEndDate=val" 
             :value="fbpSettingsData.declarationEndDate"
             class="customwidth" />
          </div>   
           <div class="">
            Reminder Frequency
          </div>
          <div class="row">
            <tl-radio
              class="col-2"
              label="Select dates"
              name="reminder"
              id="selected_days"
              value="selected_days"
              v-model="fbpSettingsData.declaration_reminder_option"
              @change="(val)=>fbpSettingsData.declaration_reminder_option=val"
            />

            <tl-radio
              class="col-3"
              label="Everyday from start date"
              name="reminder"
              id="everyday"
              value="everyday"
              v-model="fbpSettingsData.declaration_reminder_option"
              @change="(val)=>fbpSettingsData.declaration_reminder_option=val"
            />
            <tl-radio
              class="col-4"
              label="Every alternate day from start date"
              name="reminder"
              id="every_alternate_day"
              value="every_alternate_day"
              v-model="fbpSettingsData.declaration_reminder_option"
              @change="(val)=>fbpSettingsData.declaration_reminder_option=val"
            />
          </div>

          <div v-if="fbpSettingsData.declaration_reminder_option=='selected_days'">
            <ul class="days-box margin-t-xs">
                <li
                  :class="{'selected': day.selected}"
                  v-for="(day,index) in monthDaysProof"
                  :key="index"
                  :value="day.day"
                  @click="weekOffDaysProof(index)"
                >{{day.days}}</li>
              </ul> 
          </div>
           <tl-select 
                  class="col-5"
                  label="Send Reminder to" 
                  labeltext="label"
                  :value="from" 
                  :options="[{label:`Employees who didn't Declare Tax`,val:'undeclared'},
                  {label:'All Employees',val:'all_employees'}]" 
                  @change="(val)=>fbpSettingsData.declaration_reminder_people=val.val" />
           <!-- <tl-checkbox
            label="Auto-reminder to the employees who haven't declared their FBP."
            :checked="fbpSettingsData.autoReminderEmployees"
            v-model="fbpSettingsData.autoReminderEmployees"
          />
          <span>Set number of days before the last day on which auto-reminder will be sent on 
email to the employees</span>
          <div class="row">
             <div class="">
            <txt
              label="Enter Days"
              name="days"
              class="col-3"
              v-model="fbpSettingsData.daysBeforeItStartSending"
              placeholder
            />
            <a
              class="add-more col-2"
              href="javascript:void(0)"
              @click="addMore(fbpSettingsData.daysBeforeItStartSending)"
            >+ Add more</a>
            </div>
          </div> -->
          <div class="singleColumnGrid">
            <txt
              label="Email Subject"
              name="subject"
              placeholder="title here"
              v-model="fbpSettingsData.decalaration_reminder_email_subject"
            />
          </div>
          <div class="singleColumnGrid">
            <div>
              <div class="input-label">Email Body</div>
              <div class="editor-width">
                <ckeditor
                  :editor="editor"
                  v-model="fbpSettingsData.declaration_reminder_email_text"
                  :config="editorConfig"
                ></ckeditor>
              </div>
            </div>
          </div>
          <br>

          <!--Claim window-->

          <tl-checkbox label="Opening of claim window" />
         <div class="singleColumnGrid">
          <div class="label-text">
            <b>Date range for Claiming FBP</b>
          </div>
        </div>
        <div class="row">
            <tl-radio
              class="col-2"
              label="Monthly"
              name="claimdaterange"
              id="claimmonthly"
              value="monthly"
              v-model="fbpSettingsData.date_range_for_claim"
              @change="(val)=>fbpSettingsData.date_range_for_claim=val"
            />

            <tl-radio
              class="col-2"
              label="Quaterly"
              name="claimdaterange"
              id="claimquaterly"
              value="quaterly"
              v-model="fbpSettingsData.date_range_for_claim"
              @change="(val)=>fbpSettingsData.date_range_for_claim=val"
            />
            <tl-radio
              class="col-2"
              label="Half Yearly"
              name="claimdaterange"
              id="claimbi_annually"
              value="bi_annually"
              v-model="fbpSettingsData.date_range_for_claim"
              @change="(val)=>fbpSettingsData.date_range_for_claim=val"
            />
            <tl-radio
              class="col-2"
              label="Annually"
              name="claimdaterange"
              id="claimannually"
              value="annually"
              v-model="fbpSettingsData.date_range_for_claim"
              @change="(val)=>fbpSettingsData.date_range_for_claim=val"
            />
            </div>
           <!-- <br v-if="fbpSettingsData.date_range_for_claim=='quaterly'"> -->
           <div class="row" v-if="fbpSettingsData.date_range_for_claim=='quaterly'">
              <div class="col-2"></div>
                <tl-select 
                  class="col-2"
                  label="Quarter One" 
                  :value="from" 
                  :options="monthOptions" 
                  @change="(val)=>from=val" />
                <tl-select 
                  class="col-2"
                  label="Quarter Two" 
                  :value="from" 
                  :options="monthOptions" 
                  @change="(val)=>from=val" />
                <tl-select 
                  class="col-2"
                  label="Quarter Three" 
                  :value="from" 
                  :options="monthOptions" 
                  @change="(val)=>from=val" />
                <tl-select 
                  class="col-2"
                  label="Quarter Four" 
                  :value="from" 
                  :options="monthOptions" 
                  @change="(val)=>from=val" />
            </div> 
            <!-- <br v-if="fbpSettingsData.date_range_for_claim=='bi_annually'"> -->
           <div class="row" v-if="fbpSettingsData.date_range_for_claim=='bi_annually'">
              <div class="col-4"></div>
                <tl-select 
                  class="col-2"
                  label="First Half" 
                  :value="from" 
                  :options="monthOptions" 
                  @change="(val)=>from=val" />
                <tl-select 
                  class="col-2"
                  label="Second Half" 
                  :value="from" 
                  :options="monthOptions" 
                  @change="(val)=>from=val" />
            </div> 
           <!-- <br v-if="fbpSettingsData.date_range_for_claim=='annually'"> -->
           <div class="row" v-if="fbpSettingsData.date_range_for_claim=='annually'">
              <div class="col-6"></div>
                <tl-select 
                  class="col-2"
                  label="Month" 
                  :value="from" 
                  :options="monthOptions" 
                  @change="(val)=>from=val" />
            </div> 
            <div class="row">
              <!-- <div class="col-5"></div> -->
                <tl-select 
                  class="col-2"
                  label="From" 
                  :value="from" 
                  :options="monthOptions" 
                  @change="(val)=>from=val" />
                    <tl-select 
                  class="col-2"
                  label="To" 
                  :value="from" 
                  :options="monthOptions" 
                  @change="(val)=>from=val" />
            </div>  
            <br> 
        <div class="singleColumnGrid">
          <div class="label-text">
            <b>Reminder Settings</b>
          </div>
          <div>
            <span class="input-label">Start Date</span>
           <date-picker 
             @datevalue="(val)=>fbpSettingsData.declarationEndDate=val" 
             :value="fbpSettingsData.declarationEndDate"
             class="customwidth" />
          </div>   
           <div class="">
            Reminder Frequency
          </div>
          <div class="row">
            <tl-radio
              class="col-2"
              label="Select dates"
              name="claimreminder"
              id="claimselected_days"
              value="selected_days"
              v-model="fbpSettingsData.declaration_reminder_option"
              @change="(val)=>fbpSettingsData.declaration_reminder_option=val"
            />

            <tl-radio
              class="col-3"
              label="Everyday from start date"
              name="claimreminder"
              id="claimeveryday"
              value="everyday"
              v-model="fbpSettingsData.declaration_reminder_option"
              @change="(val)=>fbpSettingsData.declaration_reminder_option=val"
            />
            <tl-radio
              class="col-4"
              label="Every alternate day from start date"
              name="claimreminder"
              id="claimevery_alternate_day"
              value="every_alternate_day"
              v-model="fbpSettingsData.declaration_reminder_option"
              @change="(val)=>fbpSettingsData.declaration_reminder_option=val"
            />
          </div>

          <div v-if="fbpSettingsData.declaration_reminder_option=='selected_days'">
            <ul class="days-box margin-t-xs">
                <li
                  :class="{'selected': day.selected}"
                  v-for="(day,index) in monthDaysProof"
                  :key="index"
                  :value="day.day"
                  @click="weekOffDaysProof(index)"
                >{{day.days}}</li>
              </ul> 
          </div>
           <tl-select 
                   class="col-5"
                  label="Send Reminder to" 
                  labeltext="label"
                  :value="from" 
                  :options="[{label:`Employees who didn't Declare Tax`,val:'undeclared'},
                  {label:'All Employees',val:'all_employees'}]" 
                  @change="(val)=>fbpSettingsData.declaration_reminder_people=val.val" />
        </div>
          <div class="singleColumnGrid">
            <div>
               <txt
              label="Email Subject"
              name="subject"
              placeholder="title here"
              v-model="fbpSettingsData.claim_reminder_email_subject"
            />
            <br>
              <div class="input-label">Email Body</div>
              <div class="editor-width">
                <ckeditor
                  :editor="editor"
                  v-model="fbpSettingsData.claim_reminder_email_text"
                  :config="editorConfig"
                ></ckeditor>
              </div>
            </div>
          </div>
          <br>
          <tl-checkbox label="On Settlement of FBP claim" />
          <div class="singleColumnGrid">
            <div>
              <txt
              label="Email Subject"
              name="subject"
              placeholder="title here"
              v-model="fbpSettingsData.settlement_email_subject"
            />
            <br>
              <div class="input-label">Email Body</div>
              <div class="editor-width">
                <ckeditor
                  :editor="editor"
                  v-model="fbpSettingsData.settlement_email_text"
                  :config="editorConfig"
                ></ckeditor>
              </div>
            </div>
          </div>
          <br />
        </div>

        <div class="singleColumnGrid">
          <tl-checkbox
            label="Allow carry forward of eligibility amount to next FBP year"
            :checked="fbpSettingsData.carry_forward_unclaimed_amount_next_year"
            v-model="fbpSettingsData.carry_forward_unclaimed_amount_next_year"
          />
        </div>
        <br />
       <div class="label-text">
              <b>LOP deductions</b> 
            </div>
            <br>
            <!-- <div class="row"> -->
            <tl-radio
              class="col-6"
              label="Recover from all FBP components"
              name="lop"
              id="allcomponents"
              value="financial_year"
              v-model="fbpSettingsData.lop"
              @change="(val)=>fbpSettingsData.lop=val"
            />
             <br>
            <tl-radio
              class="col-6"
              label="Recover from Special Allowance"
              name="lop"
              id="special"
              value="calendar_year"
              v-model="fbpSettingsData.lop"
              @change="(val)=>fbpSettingsData.lop=val"
            />
            <br>
      <div class="label-text">
              <b>FBP payout to run along with</b>
            </div>
            <br>
            <!-- <div class="row"> -->
            <tl-radio
              class="col-6"
              label="Through payroll"
              name="payout"
              id="payout1"
              value="financial_year"
              v-model="fbpSettingsData.payout"
              @change="(val)=>fbpSettingsData.payout=val"
            />
             <br>
            <tl-radio
              class="col-6"
              label="Outside payroll"
              name="payout"
              id="payout2"
              value="calendar_year"
              v-model="fbpSettingsData.payout"
              @change="(val)=>fbpSettingsData.payout=val"
            />      
       <pop-up-message
         v-if="showpopup"
        message="FBP Setting Created Successfully"
         btnText="Back To Utilities"
        @back="backtoutilities()"
          >
  </pop-up-message> 
      <bottom-action-container>
        <template slot="end">
          <btn-grp>
            <btn text="Cancel" type="secondary" @click="$emit('cancelPT')" />
            <btn text="Save" type="primary" @click="saveFbpSettingsData" />
          </btn-grp>
        </template>
      </bottom-action-container>
    </div>
  <!-- </div> -->
</template>
<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { mapGetters,mapActions,mapState } from "vuex";
export default {
  name: "FbpSettings",
  data() {
    return {
      toast:false,
      errmsg:'',
      breadcrumbList:[{
            name:'Organization',
            url:`/dashboard/${this.$route.params.entity_index}/organisation`
        },{
            name:'Utilities',
            url:`/dashboard/${this.$route.params.entity_index}/organisation/utilities`
        },{
            name:'FbpSettings',
            url:`/dashboard/${this.$route.params.entity_index}/organisation/utilities/fbpsettings`
        } ],
         monthOptions: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      from:'',
      to:'',
      monthDaysProof:[{days:1,selected:false},{days:2,selected:false},{days:3,selected:false},{days:4,selected:false},{days:5,selected:false},
      {days:6,selected:false},{days:7,selected:false},{days:8,selected:false},{days:9,selected:false},
      {days:10,selected:false},{days:11,selected:false},{days:12,selected:false},{days:13,selected:false},{days:14,selected:false},{days:15,selected:false},
      {days:16,selected:false},{days:17,selected:false},{days:18,selected:false},{days:19,selected:false},
      {days:20,selected:false},{days:21,selected:false},{days:22,selected:false},{days:23,selected:false},{days:24,selected:false},{days:5,selected:false},
      {days:26,selected:false},{days:27,selected:false},{days:28,selected:false},{days:29,selected:false},
      {days:30,selected:false},{days:31,selected:false}],






      //old
      componentList: [
        {
          label: "House Rental Allowance",
          name: "houseRentalAllowance",
          checked: false
        },
        { label: "Meal Voucher", name: "mealVoucher", checked: false },
        { label: "Hostel Allowance", name: "hostelAllowance", checked: false },
        { label: "Shoping Voucher", name: "shopingVoucher", checked: false },
        { label: "Driver Salary", name: "driverSalary", checked: false },
        { label: "Union Deduction", name: "unionDeduction", checked: false },
        { label: "Car Allowance", name: "carAllowance", checked: false }
      ],
      selectedComponents: [],
      lop:'recover_all',
      fbppayout:'monthly',
      showpopup:false,
      fbpSettingsData: {
        effectiveStartDateProcessing:'date_joining',
        fbpYear:'financial_year',
        declaration_reminder_dates:[],
        lopRecoverAllComponents:true,
        payUnclaimedAmountTaxableInMarch:false,
        runFbpWithMonthlyPayroll:true,
        carryForwardFbpSettings:true,
        onClaimWindow:false,
        fbpClaimedAdvance:false,
        customDate:'',
        autoReminderEmployees:false,
        carryForwardUnclaimedAmountNextYear:false,
        carryForwardSettingsNextYear:true,
        claimEmailTemplate: {
            subject: "string",
            body: "string or html text",
          },
        onApprovalFbp:false,
        approvalEmailTemplate:{
          subject:"",
          body:""
        },
        daysBeforeItStartSending:'0',
        reminderEmailTemplate:{
          subject:"",
          body:""
        },
      },
      editor: ClassicEditor,
      editorData: "<p>Content of the editor.</p>",
      editorConfig: {
        // The configuration of the editor.
      },
      
    };
  },
  computed:{
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else {
          return this.getleid(0);
      }
    },
    ...mapState("onboard/organization", {
      orgid: state => state.id
    })
  },
  activated(){
    this.fetchfbpcomponents()
    this.toast=false
  },
  mounted(){
    // this.fetchfbpcomponents()
  },
  methods: {
    ...mapActions({
      submit_fbpSettings: "dashboard/organisation/utilities/fbpsettings/create",
      fetch_components:'dashboard/organisation/utilities/fbpsettings/fetchAllcomponents'
    }),
    getMonthDays(val) {
      this.remStart = val;
      this.calculateMonthDays();
    },
    backtoutilities(){
      this.showpopup=false
      this.$router.push(`/dashboard/${this.$route.params.entity_index}/organisation/utilities`)
    },
     weekOffDaysProof(idx) {
      this.monthDaysProof[idx].selected = !this.monthDaysProof[idx].selected;
      this.fbpSettingsData.declaration_reminder_dates.push(this.monthDaysProof[idx].days)
      // if (this.monthDaysProof[idx].selected) {
      //   this.incomeTaxModel.submissionSettings.submissionValue.push(
      //     this.monthDaysProof[idx].day
      //   );
      // } else {
      //   this.incomeTaxModel.submissionSettings.submissionValue.splice(idx, 1);
      // }
    },
    selectComponents(event, selectedItem) {
      if (event) {
        this.selectedComponents.push(selectedItem);
      } else {
        let idx = this.selectedComponents.findIndex(
          item => item.label == selectedItem.label
        );
        if (idx > -1) {
          this.selectedComponents.splice(idx, 1);
        }
      }
      //console.log(this.selectedComponents);
    },
    removeTag(val, index) {
      //console.log(val, index);
      this.selectedComponents.splice(index, 1);
      this.componentList.find(item => item.label == val.label).checked = false;
    },
    addMore(value) {
      let days = Number(value);
      this.fbpSettingsData.daysBeforeItStartSending = days + 1;
    },
    async fetchfbpcomponents(){
      let res=await this.fetch_components(this.le_id)
       if(!res){
        this.componentList= [
        {
          label: "House Rental Allowance",
          name: "houseRentalAllowance",
          checked: false
        },
        { label: "Meal Voucher", name: "mealVoucher", checked: false },
        { label: "Hostel Allowance", name: "hostelAllowance", checked: false },
        { label: "Shoping Voucher", name: "shopingVoucher", checked: false },
        { label: "Driver Salary", name: "driverSalary", checked: false },
        { label: "Union Deduction", name: "unionDeduction", checked: false },
        { label: "Car Allowance", name: "carAllowance", checked: false }
        ]
      }else{
         this.componentList=res.data.payload.data
      }
      // //console.log('ffbpcomponents',res.data)
    },
    async createFBPSettings() {
      try {
        this.fbpSettingsData.le_id=this.le_id
        this.fbpSettingsData.claimEmailTemplate.org_id=this.orgid
        this.fbpSettingsData.approvalEmailTemplate.org_id=this.orgid
        this.fbpSettingsData.reminderEmailTemplate.org_id=this.orgid
        let res = await this.submit_fbpSettings(this.fbpSettingsData);
        // if(res.message){throw error(res)}
        if(res.data.payload.data)
        this.showpopup=true
        // //console.log('fbp',this.fbpSettingsData);
        // //console.log('res',res);
      } catch (error) {
        //console.log(error);
        this.toast=true
        this.errmsg=error
      }
    },
    saveFbpSettingsData() {
      // convert selected components to ids
      // this.fbpSettingsData.fbpMutuallyExclusiveSalaryComponents = this.selectedComponents;
      this.fbpSettingsData.fbpMutuallyExclusiveSalaryComponents=[
        {"sc_id":"baf76b2f-fae1-4cc2-ac1e-6eb2192b1e68"},
      {"sc_id":"baf76b2f-fae1-4cc2-ac1e-6eb2192b1e69"}]
      this.createFBPSettings();
    }
  },
};
</script>

<style lang="scss" scoped>

ul {
  padding-left: 0px;
  margin-left: 24px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.flex-box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-radius: 4px;
  background: #f9f9f9;
  li {
    list-style: none;
    font-weight: 500;
    padding: 15px 10px;
    cursor: pointer;
    &:hover,
    &.selected {
      background-color: #34c0be;
    }
  }
}

.editor-width {
  width: 650px;
}

.selected-badges {
  border-radius: 10px;
  border: solid 1px #f2f2f2;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  background-color: #ffffff;
  padding: 10px;
}

.fbp-badges {
  width: auto;
  height: 28px;
  display: inline-block;
  justify-content: space-between;
  margin-left: 10px;
  margin-bottom: 10px;
  *:nth-child(1) {
    margin-right: 10px;
    padding-left: 5px;
  }
  img {
    margin-top: 3px;
    margin-right: 10px;
    cursor: pointer;
  }
}

.add-more {
  width: 30%;
  color: #5d409f;
  position: relative;
  top: 25px;
}

.small-text {
  font-size: 12px;
  margin-left: 2rem;
}

.align-filters {
  margin-top: 10px;
  button {
    border-radius: 100px;
    background-color: #b2f8f7;
  }
}

.btnGrp {
  float: right;
}
// new

.days-box {
  // display: flex;
  // flex-direction: row;
  width:85%;
  justify-content: space-between;
  border-radius: 4px;
  background: #f9f9f9;
  li {
    list-style: none;
    display: inline-block;
    font-weight: 500;
    margin-top: 5px;
    padding: 15px 27px;
    cursor: pointer;
    &:hover,
    &.selected {
      background-color: #34c0be;
      
    }
  }
}
.customwidth{
  width: 200px;
}
</style>
